import { PrimitiveAtom } from 'jotai/vanilla/atom';
import { ListSettingsAtomValue } from 'shared/_components/list/types';
import { useAtom } from 'jotai/index';
import { useCallback } from 'react';
import { ToggleButton } from '@mui/material';
import { IconFilter } from 'shared/components/ListFilter/IconFilter';

type PageFiltersIconButtonProps = {
	settingsAtom: PrimitiveAtom<ListSettingsAtomValue> & { init: ListSettingsAtomValue }
}

export function PageFiltersIconButton({ settingsAtom }: PageFiltersIconButtonProps) {
	const [{ showFilters }, setSettings] = useAtom(settingsAtom);
	const toggleFilters = useCallback(() => {
		setSettings((s) => ({ ...s, showFilters: !s.showFilters }))
	}, [setSettings]);

	return (
		<ToggleButton value="check" selected={showFilters} onChange={toggleFilters}>
			<IconFilter />
		</ToggleButton>
	);
}
